import React from "react";
import { Modal, Button } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

const DiscardConfirmationDialog = ({
  onCancel = () => {},
  onConfirm = () => {},
}) => {
  const { t } = useI18n();
  return (
    <Modal
      width="480px"
      height="max-content"
      dsVersion="2.0"
      onClose={onCancel}
      hasOverlay={true}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={false}
    >
      <Modal.Header title={t("common:discard_changes")} isClosable={true} />
      <Modal.Body>{t("journal:goals_discard_alert_body_text")}</Modal.Body>
      <Modal.Footer
        style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
      >
        <Button
          dsVersion="2.0"
          variant="neutral"
          type="outlined"
          onClick={onCancel}
        >
          {t("journal:continue_editing")}
        </Button>
        <Button dsVersion="2.0" variant="destructive" onClick={onConfirm}>
          {t("common:discard_changes")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DiscardConfirmationDialog.displayName = "DiscardConfirmationDialog";
export default DiscardConfirmationDialog;
